module.exports = __webpack_public_path__ + "media/webfonts/fa-brands-400-13685372.ttf";